module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACSSURBVHgB7ZbBCYNAEEXfJmXEQwpID0kpSSfpJCklqUG9e7EMGRnQ2yq4iqL8BwMDCzsPdv+yIISYQcHl6cUW+OCSzLzmSJxIxAjXWL+awFJIQAJhbNHjNXTDz3A3eHSb/Br4xwdYdaP+MlXAhwfChwUw7DUkoSNIJid790+x9ySiGEpgvwIer1i/Kpt+yYQ4DC1dZjKW5HtLSAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/model-follow.png
// module id = bMVV
// module chunks = 36